import { Day } from 'date-fns';
import { WeekDays } from 'shared/types/week-days';

export * as FilterDocuments from './filter-document';
export * as NLP from './nlp';

// can be found in `vite.config.ts`
export const version = __APP_VERSION__;

export const iosDownloadLink =
  'https://apps.apple.com/us/app/griply-control-your-life/id1556692747';

export {
  defaultLimitKeyMap,
  premiumLimitKeyMap,
  unlimitedLimit,
} from '@griply/utils';

export const weekdaysNumberMap: Record<WeekDays, Day> = {
  [WeekDays.Monday]: 1,
  [WeekDays.Tuesday]: 2,
  [WeekDays.Wednesday]: 3,
  [WeekDays.Thursday]: 4,
  [WeekDays.Friday]: 5,
  [WeekDays.Saturday]: 6,
  [WeekDays.Sunday]: 0,
};

export const reminderTimes = [
  9 * 60 * 60 * 1000, // 09:00
  12 * 60 * 60 * 1000, // 12:00
  15 * 60 * 60 * 1000, // 15:00
  18 * 60 * 60 * 1000, // 18:00
  21 * 60 * 60 * 1000, // 21:00
];

export const sideNavigationHoverClass = 'side-navigation-show-on-hover';

export const shortcutsLink =
  'https://griply.app/help/features/keyboard-shortcuts';
export const redditLink = 'https://www.reddit.com/r/GriplyApp/';
export const discordLink = 'https://discord.gg/4ptd9hGw5V';
export const helpCenterLink = 'https://griply.app/help';
export const changelogLink = 'https://griply.app/changelog';

export const subTaskLevel = 1;

export const durationOptions = [
  900000, // 00:15 (15 minutes)
  1800000, // 00:30 (30 minutes)
  2700000, // 00:45 (45 minutes)
  3600000, // 01:00 (1 hour)
  5400000, // 01:30 (1.5 hours)
  7200000, // 02:00 (2 hours)
  10800000, // 03:00 (3 hours)
  14400000, // 04:00 (4 hours)
];

export const halfHour = 30 * 60 * 1000;

export const newTrialAllowedDate = new Date('2024-06-10T00:00:00Z');
